import { render, staticRenderFns } from "./Insight_Game.vue?vue&type=template&id=a08d72f4&scoped=true"
import script from "./Insight_Game.vue?vue&type=script&lang=js"
export * from "./Insight_Game.vue?vue&type=script&lang=js"
import style0 from "./Insight_Game.vue?vue&type=style&index=0&id=a08d72f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d72f4",
  null
  
)

export default component.exports